import { render, staticRenderFns } from "./MobileCommunityBusinessnews.vue?vue&type=template&id=1b04dc6a&scoped=true&"
import script from "./MobileCommunityBusinessnews.vue?vue&type=script&lang=js&"
export * from "./MobileCommunityBusinessnews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b04dc6a",
  null
  
)

export default component.exports